module.exports = __webpack_public_path__ + "static/showreel_2025-1de772c1406fe5d5cdca458512c158c6.jpg";